module.exports = __webpack_public_path__ + "img/join.7091bdb9.png";